import slide1 from '@/assets/onboarding/slide-1-chat-gantt.jpg';
import slide2 from '@/assets/onboarding/slide-2-signal.jpg';
import slide3 from '@/assets/onboarding/slide-3-nesting.jpg';
import slide4 from '@/assets/onboarding/slide-4-copilot.jpg';
import slide5 from '@/assets/onboarding/slide-5-batteries.jpg';

export interface IntroSlide {
  kicker: string;
  title: string;
  body: string;
  bullets: string[];
  image: string;
  imageAlt: string;
}

export const INTRO_SLIDES: IntroSlide[] = [
  {
    kicker: 'One workspace',
    title: 'Chat and Gantt, side by side.',
    body: 'TaskBot lives beside your plan — not in a separate tab, not behind a modal. Every menu, filter, and drag has a plain-English equivalent.',
    bullets: [
      '"add a task for Friday" instead of hunting for a button',
      '"link Day 2 to Day 3" instead of drawing arrows',
      'The Gantt is the source of truth — the chat is how you drive it',
    ],
    image: slide1,
    imageAlt: 'A chat panel and Gantt timeline connected as one workspace.',
  },
  {
    kicker: 'No status theater',
    title: 'Signal-based tracking.',
    body: 'Workitect refuses the "In Progress / Blocked / Waiting" ritual. Progress is derived from what actually happened — checked action items, check-ins, approvals.',
    bullets: [
      'Percent complete rolls up from real signals, not self-reported labels',
      'Stalled tasks surface automatically in the Daily Brief',
      'Nothing to keep "updated" for its own sake',
    ],
    image: slide2,
    imageAlt: 'Progress signals radiating from a completed checkmark.',
  },
  {
    kicker: 'Deliberately shallow',
    title: 'Two levels. That\'s the whole hierarchy.',
    body: 'A Project holds tasks. Tasks hold action items. That\'s it. Every attempt to nest deeper triggers a negotiation with TaskBot — because five-level trees are where plans go to die.',
    bullets: [
      'Top-Level Projects are the only "folder"',
      'Action items handle the fine detail without becoming ghost tasks',
      'Legible on day one, still legible on day ninety',
    ],
    image: slide3,
    imageAlt: 'A two-tier hierarchy with a third layer greyed out.',
  },
  {
    kicker: 'Opinionated AI',
    title: 'A copilot that will push back.',
    body: 'TaskBot is warm, direct, and anti-corporate. It refuses tooling theater, respects role boundaries, and will tell you when a plan doesn\'t make sense — instead of quietly executing it.',
    bullets: [
      'Regular Users can only edit tasks they own — TaskBot enforces it',
      'Boundary violations trigger negotiation, not silent failure',
      'Warns before you create dependency cycles or overbook the week',
    ],
    image: slide4,
    imageAlt: 'A friendly copilot avatar beside a task guarded by a rail.',
  },
  {
    kicker: 'Batteries included',
    title: 'The important things are built in.',
    body: 'Approvals, recurrences, media review with time-coded notes, intake forms, and MCP for external agents — no add-ons, no per-feature paywall.',
    bullets: [
      'Round-based approvals as a first-class task concept',
      'Time-coded review for video, audio, PDFs, and images',
      'Agent integrations via MCP so ChatGPT or Claude can act on your data',
    ],
    image: slide5,
    imageAlt: 'An open toolbox with approvals, recurrence, media, and integration icons.',
  },
];
